export function initFeaturesTabsParallax(lenis) {
	const sections = document.querySelectorAll('.features-tabs')
	if (!sections.length) return

	const isDesktop = () => window.matchMedia('(min-width: 768px)').matches

	const updateParallax = () => {
		if (!isDesktop()) {
			document
				.querySelectorAll('.features-tabs__image-top, .features-tabs__image-middle, .features-tabs__image-bottom')
				.forEach(el => {
					el.style.transform = ''
				})
			return
		}

		sections.forEach(section => {
			const rect = section.getBoundingClientRect()
			const viewportHeight = window.innerHeight
			const sectionCenter = rect.top + rect.height / 2
			const viewportCenter = viewportHeight / 2

			let progress = (sectionCenter - viewportCenter) / viewportHeight
			progress = Math.max(-1, Math.min(1, progress))

			const topOffset = progress * -25
			const middleOffset = progress * 15
			const bottomOffset = progress * 35

			const topX = progress * 8
			const middleX = progress * -35
			const bottomX = progress * 8

			const topElements = section.querySelectorAll('.features-tabs__image-top')
			const middleElements = section.querySelectorAll('.features-tabs__image-middle')
			const bottomElements = section.querySelectorAll('.features-tabs__image-bottom')

			topElements.forEach(el => {
				el.style.transform = `translate3d(${topX}px, ${topOffset}px, 0)`
			})

			middleElements.forEach(el => {
				el.style.transform = `translate3d(${middleX}px, ${middleOffset}px, 0)`
			})

			bottomElements.forEach(el => {
				el.style.transform = `translate3d(${bottomX}px, ${bottomOffset}px, 0)`
			})
		})
	}

	if (lenis && typeof lenis.on === 'function') {
		lenis.on('scroll', updateParallax)
	} else {
		window.addEventListener('scroll', updateParallax, { passive: true })
	}

	window.addEventListener('resize', updateParallax)
	updateParallax()
}
